import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/lib/auth";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ResetPassword from "@/pages/ResetPassword";
import DashboardLayout from "@/pages/DashboardLayout";
import OffersList from "@/pages/OffersList";
import OfferNew from "@/pages/OfferNew";
import OfferDetail from "@/pages/OfferDetail";
import JobsList from "@/pages/JobsList";
import JobDetail from "@/pages/JobDetail";
import ProjectManager from "@/pages/ProjectManager";
import CalendarPage from "@/pages/Calendar";
import DocumentsCenter from "@/pages/DocumentsCenter";
import DocumentEditor from "@/pages/DocumentEditor";
import Invoices from "@/pages/Invoices";
import InvoiceEditor from "@/pages/InvoiceEditor";
import Settings from "@/pages/Settings";
import Billing from "@/pages/Billing";
import BillingSuccess from "@/pages/BillingSuccess";
import Admin from "@/pages/Admin";
import PublicOffer from "@/pages/PublicOffer";
import "@/App.css";

function Private({ children, admin = false }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-sm text-[#94A3B8]">Se încarcă…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (admin && !user.is_admin) return <Navigate to="/app/oferte" replace />;
  return children;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="bottom-right" richColors />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/app" element={<Private><DashboardLayout /></Private>}>
            <Route index element={<Navigate to="/app/oferte" replace />} />
            <Route path="oferte" element={<OffersList />} />
            <Route path="oferte/noua" element={<OfferNew />} />
            <Route path="oferte/:id" element={<OfferDetail />} />
            <Route path="lucrari" element={<JobsList />} />
            <Route path="lucrari/:id" element={<JobDetail />} />
            <Route path="lucrari/:id/proiect" element={<ProjectManager />} />
            <Route path="calendar" element={<CalendarPage />} />
            <Route path="documente" element={<DocumentsCenter />} />
            <Route path="documente/nou/:type" element={<DocumentEditor />} />
            <Route path="documente/:id" element={<DocumentEditor />} />
            <Route path="facturare" element={<Invoices />} />
            <Route path="facturare/nou/:kind" element={<InvoiceEditor />} />
            <Route path="facturare/:id" element={<InvoiceEditor />} />
            <Route path="setari" element={<Settings />} />
            <Route path="abonament" element={<Billing />} />
            <Route path="admin" element={<Private admin><Admin /></Private>} />
          </Route>
          <Route path="/billing/success" element={<Private><BillingSuccess /></Private>} />
          <Route path="/oferta/:id" element={<PublicOffer />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
